// @ts-nocheck
import type * as Types from '../types/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WorkspaceFragment = { __typename?: 'Workspace', id: string, created: number, name: string, timezone: string, stripeAccountConnected: boolean, nonprofitName: string, nonprofitTaxId: string, taxNote: string, taxFMVNote: string, website?: string | null, logoUrl?: string | null, verified: boolean, needsVerification: boolean, stripeAccountType?: Types.StripeAccountType | null, stripeAccountStatus: Types.StripeAccountStatus, needsStripeAccount: boolean, smsCampaignsEnabled: boolean, emailPopupEnabled: boolean, statementDescriptor?: string | null, googleAnalyticsId?: string | null, googleTagManagerId?: string | null, googleAdsConversionId?: string | null, googleAdsConversionLabel?: string | null, facebookPixelId?: string | null, mailchimpConnected: boolean, mailchimpAudienceName?: string | null, maxNumberOfPhoneNumbers: number, constantContactConnected: boolean, constantContactListName?: string | null, salesforceConnected: boolean, salesforceStageName?: string | null, salesforceContactRecordTypeName?: string | null, salesforceAccountRecordTypeName?: string | null, salesforceCampaignRecordTypeName?: string | null, salesforceOpportunityRecordTypeName?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedInUrl?: string | null, youtubeUrl?: string | null, emailSenderName?: string | null, emailSenderEmail?: string | null, doubleTheDonationConnected: boolean, doubleTheDonationPublicKey?: string | null, textToDonateEnabled: boolean, billingPlan: Types.BillingPlanName, address: { __typename?: 'NonprofitAddress', addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zip?: string | null }, facebookPage?: { __typename?: 'FacebookPage', id: string, name: string, profilePictureUrl: string } | null };

export type UserFragment = { __typename?: 'CurrentUser', id: string, email: string, firstName?: string | null, lastName?: string | null, phone?: string | null, profilePictureUrl?: string | null, state: Types.UserState, emailVerifiedAt?: number | null, isMasterAdmin: boolean, roles: Array<{ __typename?: 'WorkspaceRole', role: Types.Role, workspace: { __typename?: 'Workspace', id: string, created: number, name: string, timezone: string, stripeAccountConnected: boolean, nonprofitName: string, nonprofitTaxId: string, taxNote: string, taxFMVNote: string, website?: string | null, logoUrl?: string | null, verified: boolean, needsVerification: boolean, stripeAccountType?: Types.StripeAccountType | null, stripeAccountStatus: Types.StripeAccountStatus, needsStripeAccount: boolean, smsCampaignsEnabled: boolean, emailPopupEnabled: boolean, statementDescriptor?: string | null, googleAnalyticsId?: string | null, googleTagManagerId?: string | null, googleAdsConversionId?: string | null, googleAdsConversionLabel?: string | null, facebookPixelId?: string | null, mailchimpConnected: boolean, mailchimpAudienceName?: string | null, maxNumberOfPhoneNumbers: number, constantContactConnected: boolean, constantContactListName?: string | null, salesforceConnected: boolean, salesforceStageName?: string | null, salesforceContactRecordTypeName?: string | null, salesforceAccountRecordTypeName?: string | null, salesforceCampaignRecordTypeName?: string | null, salesforceOpportunityRecordTypeName?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedInUrl?: string | null, youtubeUrl?: string | null, emailSenderName?: string | null, emailSenderEmail?: string | null, doubleTheDonationConnected: boolean, doubleTheDonationPublicKey?: string | null, textToDonateEnabled: boolean, billingPlan: Types.BillingPlanName, address: { __typename?: 'NonprofitAddress', addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zip?: string | null }, facebookPage?: { __typename?: 'FacebookPage', id: string, name: string, profilePictureUrl: string } | null } }> };

export type CurrentUserQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'CurrentUser', id: string, email: string, firstName?: string | null, lastName?: string | null, phone?: string | null, profilePictureUrl?: string | null, state: Types.UserState, emailVerifiedAt?: number | null, isMasterAdmin: boolean, roles: Array<{ __typename?: 'WorkspaceRole', role: Types.Role, workspace: { __typename?: 'Workspace', id: string, created: number, name: string, timezone: string, stripeAccountConnected: boolean, nonprofitName: string, nonprofitTaxId: string, taxNote: string, taxFMVNote: string, website?: string | null, logoUrl?: string | null, verified: boolean, needsVerification: boolean, stripeAccountType?: Types.StripeAccountType | null, stripeAccountStatus: Types.StripeAccountStatus, needsStripeAccount: boolean, smsCampaignsEnabled: boolean, emailPopupEnabled: boolean, statementDescriptor?: string | null, googleAnalyticsId?: string | null, googleTagManagerId?: string | null, googleAdsConversionId?: string | null, googleAdsConversionLabel?: string | null, facebookPixelId?: string | null, mailchimpConnected: boolean, mailchimpAudienceName?: string | null, maxNumberOfPhoneNumbers: number, constantContactConnected: boolean, constantContactListName?: string | null, salesforceConnected: boolean, salesforceStageName?: string | null, salesforceContactRecordTypeName?: string | null, salesforceAccountRecordTypeName?: string | null, salesforceCampaignRecordTypeName?: string | null, salesforceOpportunityRecordTypeName?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedInUrl?: string | null, youtubeUrl?: string | null, emailSenderName?: string | null, emailSenderEmail?: string | null, doubleTheDonationConnected: boolean, doubleTheDonationPublicKey?: string | null, textToDonateEnabled: boolean, billingPlan: Types.BillingPlanName, address: { __typename?: 'NonprofitAddress', addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zip?: string | null }, facebookPage?: { __typename?: 'FacebookPage', id: string, name: string, profilePictureUrl: string } | null } }> } };

export const WorkspaceFragmentDoc = /*#__PURE__*/ gql`
    fragment Workspace on Workspace {
  id
  created
  name
  timezone
  stripeAccountConnected
  timezone
  nonprofitName
  nonprofitTaxId
  taxNote
  taxFMVNote
  website
  address {
    addressLine1
    addressLine2
    city
    state
    zip
  }
  logoUrl
  verified
  needsVerification
  stripeAccountConnected
  stripeAccountType
  stripeAccountStatus
  needsStripeAccount
  smsCampaignsEnabled
  emailPopupEnabled
  statementDescriptor
  facebookPage {
    id
    name
    profilePictureUrl
  }
  googleAnalyticsId
  googleTagManagerId
  googleAdsConversionId
  googleAdsConversionLabel
  facebookPixelId
  mailchimpConnected
  mailchimpAudienceName
  maxNumberOfPhoneNumbers
  constantContactConnected
  constantContactListName
  salesforceConnected
  salesforceStageName
  salesforceContactRecordTypeName
  salesforceAccountRecordTypeName
  salesforceCampaignRecordTypeName
  salesforceOpportunityRecordTypeName
  facebookUrl
  twitterUrl
  instagramUrl
  linkedInUrl
  youtubeUrl
  emailSenderName
  emailSenderEmail
  doubleTheDonationConnected
  doubleTheDonationPublicKey
  textToDonateEnabled
  billingPlan
}
    `;
export const UserFragmentDoc = /*#__PURE__*/ gql`
    fragment User on CurrentUser {
  id
  email
  firstName
  lastName
  phone
  profilePictureUrl
  roles {
    role
    workspace {
      ...Workspace
    }
  }
  state
  emailVerifiedAt
  isMasterAdmin
}
    ${WorkspaceFragmentDoc}`;
export const CurrentUserDocument = /*#__PURE__*/ gql`
    query CurrentUser {
  currentUser {
    ...User
  }
}
    ${UserFragmentDoc}`;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export function useCurrentUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserSuspenseQueryHookResult = ReturnType<typeof useCurrentUserSuspenseQuery>;
export function refetchCurrentUserQuery(variables?: CurrentUserQueryVariables) {
      return { query: CurrentUserDocument, variables: variables }
    }